// Redux Tasks module
// see https://github.com/erikras/ducks-modular-redux

import { Tasks } from '../../services';
import { createRestSlices, applyReducers } from './rest';

const LOADING_TASKS                  = 'kronos/tasks/LOADING_TASKS';
const LOADING_TASKS_SUCCESS          = 'kronos/tasks/LOADING_TASKS_SUCCESS';
const LOADING_TASKS_FAILURE          = 'kronos/tasks/LOADING_TASKS_FAILURE';
const RESET_TASK                     = 'kronos/tasks/RESET_TASK';
const RESET_TASK_DELETE_SUCCESS      = 'kronos/tasks/RESET_TASK_DELETE_SUCCESS';
const LOADING_TASK                   = 'kronos/tasks/LOADING_TASK';
const LOADING_TASK_SUCCESS           = 'kronos/tasks/LOADING_TASK_SUCCESS';
const LOADING_TASK_FAILURE           = 'kronos/tasks/LOADING_TASK_FAILURE';
const UPDATING_TASK                  = 'kronos/tasks/UPDATING_TASK';
const UPDATING_TASK_SUCCESS          = 'kronos/tasks/UPDATING_TASK_SUCCESS';
const UPDATING_TASK_FAILURE          = 'kronos/tasks/UPDATING_TASK_FAILURE';
const START_CREATING_TASK            = 'kronos/tasks/START_CREATING_TASK';
const CREATING_TASK                  = 'kronos/tasks/CREATING_TASK';
const CREATING_TASK_SUCCESS          = 'kronos/tasks/CREATING_TASK_SUCCESS';
const CREATING_TASK_FAILURE          = 'kronos/tasks/CREATING_TASK_FAILURE';
const DELETING_TASK                  = 'kronos/tasks/DELETING_TASK';
const DELETING_TASK_SUCCESS          = 'kronos/tasks/DELETING_TASK_SUCCESS';
const DELETING_TASK_FAILURE          = 'kronos/tasks/DELETING_TASK_FAILURE';
const ASSIGNING_TASK                 = 'kronos/tasks/ASSIGNING_TASK';
const ASSIGNING_TASK_SUCCESS         = 'kronos/tasks/ASSIGNING_TASK_SUCCESS';
const ASSIGNING_TASK_FAILURE         = 'kronos/tasks/ASSIGNING_TASK_FAILURE';
const CHANGING_TASK_STATUS           = 'kronos/tasks/CHANGING_TASK_STATUS';
const CHANGING_TASK_STATUS_SUCCESS   = 'kronos/tasks/CHANGING_TASK_STATUS_SUCCESS';
const CHANGING_TASK_STATUS_FAILURE   = 'kronos/tasks/CHANGING_TASK_STATUS_FAILURE';
const CLAIMING_TASK                  = 'kronos/tasks/CLAIMING_TASK';
const CLAIMING_TASK_SUCCESS          = 'kronos/tasks/CLAIMING_TASK_SUCCESS';
const CLAIMING_TASK_FAILURE          = 'kronos/tasks/CLAIMING_TASK_FAILURE';
const ACCEPTING_TASK                 = 'kronos/tasks/ACCEPTING_TASK';
const ACCEPTING_TASK_SUCCESS         = 'kronos/tasks/ACCEPTING_TASK_SUCCESS';
const ACCEPTING_TASK_FAILURE         = 'kronos/tasks/ACCEPTING_TASK_FAILURE';
const REFUSING_TASK                  = 'kronos/tasks/REFUSING_TASK';
const REFUSING_TASK_SUCCESS          = 'kronos/tasks/REFUSING_TASK_SUCCESS';
const REFUSING_TASK_FAILURE          = 'kronos/tasks/REFUSING_TASK_FAILURE';
const RENOUNCING_TASK                = 'kronos/tasks/RENOUNCING_TASK';
const RENOUNCING_TASK_SUCCESS        = 'kronos/tasks/RENOUNCING_TASK_SUCCESS';
const RENOUNCING_TASK_FAILURE        = 'kronos/tasks/RENOUNCING_TASK_FAILURE';

const { initialState, linkedResourcesReducer, linkedResourcesAction } = createRestSlices(Tasks);

initialState.isLoading = false;
initialState.listFetchScope = 'idle';
initialState.listRequestId = 0;
initialState.hasLoadingError = false;
initialState.loadingErrorMessage = '';
initialState.taskSuccessfullyCreated = false;
initialState.tasks = [];
initialState.task = null;
initialState.loadingTaskId = null;

/** Monotonic id so only the latest /task/list response updates Redux. */
let tasks_list_request_seq = 0;

// Reducer
const reducer = (state = initialState, action) => {
    switch(action.type) {
        case RESET_TASK:
            return { ...state, task: null };
        case RESET_TASK_DELETE_SUCCESS:
            return { ...state, taskSuccessfullyDeleted: false };
        case LOADING_TASKS:
            return {
                ...state,
                isLoading: true,
                listFetchScope: action.fetchScope ?? 'major',
                listRequestId: action.requestId,
                hasLoadingError: false
            };
        case LOADING_TASKS_SUCCESS:
            if (action.requestId != null && action.requestId !== state.listRequestId) {
                return state;
            }
            return {
                ...state,
                isLoading: false,
                listFetchScope: 'idle',
                hasLoadingError: false,
                tasks: Array.isArray(action.tasks) ? action.tasks : [],
            };
        case LOADING_TASKS_FAILURE:
            if (action.requestId != null && action.requestId !== state.listRequestId) {
                return state;
            }
            return {
                ...state,
                isLoading: false,
                listFetchScope: 'idle',
                hasLoadingError: true,
                loadingErrorMessage: action.error.message
            };
        case LOADING_TASK:
            return {
                ...state,
                isLoading: true,
                loadingTaskId: action.requestedId,
                hasLoadingError: false,
                taskSuccessfullyDeleted: false,
            };
        case LOADING_TASK_SUCCESS:
            if (action.requestedId != null && action.requestedId !== state.loadingTaskId) {
                return state;
            }
            return {
                ...state,
                isLoading: false,
                loadingTaskId: null,
                hasLoadingError: false,
                task: action.task
            };
        case LOADING_TASK_FAILURE:
            if (action.requestedId != null && action.requestedId !== state.loadingTaskId) {
                return state;
            }
            return {
                ...state,
                isLoading: false,
                loadingTaskId: null,
                hasLoadingError: true,
                loadingErrorMessage: action.error.message
            };
        case UPDATING_TASK:
            return {
                ...state,
                isLoading: true,
                hasLoadingError: false
            };
        case UPDATING_TASK_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false,
                task: action.task
            };
        case UPDATING_TASK_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: true,
                loadingErrorMessage: action.error.message
            };
        case START_CREATING_TASK:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false,
                taskSuccessfullyCreated: false,
                task: action.task || {}
            };
        case CREATING_TASK:
            return {
                ...state,
                isLoading: true,
                hasLoadingError: false
            };
        case CREATING_TASK_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false,
                taskSuccessfullyCreated: true,
                task: action.task
            };
        case CREATING_TASK_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: true,
                taskSuccessfullyCreated: false,
                loadingErrorMessage: action.error.message
            };
        case DELETING_TASK:
            return {
                ...state,
                isLoading: true,
                hasLoadingError: false
            };
        case DELETING_TASK_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false,
                taskSuccessfullyDeleted: true,
                task: action.task,
                tasks: action.taskId
                    ? state.tasks.filter((t) => t.id !== action.taskId)
                    : state.tasks,
            };
        case DELETING_TASK_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: true,
                taskSuccessfullyDeleted: false,
                loadingErrorMessage: action.error.message
            };
        case ASSIGNING_TASK:
            return {
                ...state,
                isLoading: true,
                hasLoadingError: false
            };
        case ASSIGNING_TASK_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false,
                task: action.task,
                tasks: state.tasks.map((t) => t.id === action.task.id ? action.task : t),
            };
        case ASSIGNING_TASK_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: true,
                loadingErrorMessage: action.error.message
            };
        case CHANGING_TASK_STATUS:
            return {
                ...state,
                isLoading: true,
                hasLoadingError: false
            };
        case CHANGING_TASK_STATUS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false,
                task: action.task,
                tasks: state.tasks.map((t) => t.id === action.task.id ? {
                    ...t,
                    ...action.task,
                    screening: t.screening
                } : t),
            };
        case CHANGING_TASK_STATUS_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: true,
                loadingErrorMessage: action.error.message
            };
        case CLAIMING_TASK:
            return {
                ...state,
                isLoading: true,
                hasLoadingError: false
            };
        case CLAIMING_TASK_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false,
                task: action.task,
                tasks: state.tasks.map((t) => t.id === action.task.id ? action.task : t),
            };
        case CLAIMING_TASK_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: true,
                loadingErrorMessage: action.error.message
            };
        case ACCEPTING_TASK:
            return {
                ...state,
                isLoading: true,
                hasLoadingError: false
            };
        case ACCEPTING_TASK_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false,
                task: action.task,
                tasks: state.tasks.map((t) => t.id === action.task.id ? action.task : t),
            };
        case ACCEPTING_TASK_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: true,
                loadingErrorMessage: action.error.message
            };
        case REFUSING_TASK:
            return {
                ...state,
                isLoading: true,
                hasLoadingError: false
            };
        case REFUSING_TASK_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false,
                task: action.task,
                tasks: state.tasks.map((t) => t.id === action.task.id ? action.task : t),
            };
        case REFUSING_TASK_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: true,
                loadingErrorMessage: action.error.message
            };
        case RENOUNCING_TASK:
            return {
                ...state,
                isLoading: true,
                hasLoadingError: false
            };
        case RENOUNCING_TASK_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false,
                task: action.task,
                tasks: state.tasks.map((t) => t.id === action.task.id ? action.task : t),
            };
        case RENOUNCING_TASK_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: true,
                loadingErrorMessage: action.error.message
            };
        default:
            return state;
    }
};

/* Export reducer */
export default (state = initialState, action) => {
    return applyReducers(state, action, [ linkedResourcesReducer, reducer ]);
}

// Actions
function loadingTasks(fetchScope, requestId) {
    return { type: LOADING_TASKS, fetchScope, requestId };
}
function loadingTasksSuccess(tasks, requestId) {
    return { type: LOADING_TASKS_SUCCESS, tasks, requestId };
}
function loadingTasksFailure(err, requestId) {
    return { type: LOADING_TASKS_FAILURE, error: err, requestId };
}
export function loadTasks(params, callback) {
    const { fetchScope, ...listParams } = params || {};
    return (dispatch, getState) => {
        const requestId = ++tasks_list_request_seq;
        dispatch(loadingTasks(fetchScope, requestId));
        Tasks.list(listParams)
            .then(data => {
                const list = Array.isArray(data.tasks) ? data.tasks : [];
                dispatch(loadingTasksSuccess(list, requestId));
                if (getState().tasks.listRequestId === requestId)
                    callback && callback(list);
            })
            .catch(err => {
                dispatch(loadingTasksFailure(err, requestId))
                if (getState().tasks.listRequestId === requestId)
                    callback && callback(undefined, err);
            });
    }
}

function loadingTask(requestedId) { return { type: LOADING_TASK, requestedId } }
function loadingTaskSuccess(task, requestedId) { return { type: LOADING_TASK_SUCCESS, task, requestedId } }
function loadingTaskFailure(err, requestedId) { return { type: LOADING_TASK_FAILURE, error: err, requestedId } }
export function resetTask() {
    return (dispatch) => dispatch({ type: RESET_TASK });
}
export function resetTaskDeleteSuccess() {
    return (dispatch) => dispatch({ type: RESET_TASK_DELETE_SUCCESS });
}
export function loadTask(taskId) {
    return (dispatch) => {
        dispatch(loadingTask(taskId));
        Tasks.get(taskId)
            .then(data => {
                const task = data.task;
                dispatch(loadingTaskSuccess(task, taskId));
            })
            .catch(err => {
                dispatch(loadingTaskFailure(err, taskId))
            });
    }
}

function updatingTask() { return { type: UPDATING_TASK } }
function updatingTaskSuccess(task) { return { type: UPDATING_TASK_SUCCESS, task: task } }
function updatingTaskFailure(err) { return { type: UPDATING_TASK_FAILURE, error: err } }
export function updateTask(task) {
    return (dispatch) => {
        dispatch(updatingTask());
        Tasks.update(task)
            .then(data => {
                const task = data.task;
                dispatch(updatingTaskSuccess(task));
            })
            .catch(err => {
                dispatch(updatingTaskFailure(err))
            });
    }
}

function creatingTask() { return { type: CREATING_TASK } }
function creatingTaskSuccess(task) { return { type: CREATING_TASK_SUCCESS, task: task } }
function creatingTaskFailure(err) { return { type: CREATING_TASK_FAILURE, error: err } }
export function startCreateTask(task = {}) { return { type: START_CREATING_TASK, task } }
export function createTask(task) {
    return (dispatch) => {
        dispatch(creatingTask());
        Tasks.create(task)
            .then(data => {
                const task = data.task;
                dispatch(creatingTaskSuccess(task));
                dispatch(loadingTaskSuccess(task));
            })
            .catch(err => {
                dispatch(creatingTaskFailure(err))
            });
    }
}

function deletingTask() { return { type: DELETING_TASK } }
function deletingTaskSuccess(taskId) { return { type: DELETING_TASK_SUCCESS, taskId } }
function deletingTaskFailure(err) { return { type: DELETING_TASK_FAILURE, error: err } }
export function deleteTask(taskId) {
    return (dispatch) => {
        dispatch(deletingTask());
        Tasks.delete(taskId)
            .then(() => {
                dispatch(deletingTaskSuccess(taskId));
            })
            .catch(err => {
                dispatch(deletingTaskFailure(err))
            });
    }
}

function assigningTask() { return { type: ASSIGNING_TASK } }
function assigningTaskSuccess(task) { return { type: ASSIGNING_TASK_SUCCESS, task: task } }
function assigningTaskFailure(err) { return { type: ASSIGNING_TASK_FAILURE, error: err } }
export function assignTask(task, user_id, callback) {
    return (dispatch) => {
        dispatch(assigningTask());
        Tasks.assign(task, user_id)
            .then(data => {
                dispatch(assigningTaskSuccess(data.task));
                callback && callback(/*err*/null, data.task);
            })
            .catch(err => {
                dispatch(assigningTaskFailure(err))
                callback && callback(err);
            });
    }
}

function changingTaskStatus() { return { type: CHANGING_TASK_STATUS } }
function changingTaskStatusSuccess(task) { return { type: CHANGING_TASK_STATUS_SUCCESS, task: task } }
function changingTaskStatusFailure(err) { return { type: CHANGING_TASK_STATUS_FAILURE, error: err } }
export function changeTaskStatus(task, status, callback) {
    return (dispatch) => {
        dispatch(changingTaskStatus());
        Tasks.change_status(task, status)
            .then(data => {
                dispatch(changingTaskStatusSuccess(data.task));
                callback && callback(/*err*/null, data.task);
            })
            .catch(err => {
                dispatch(changingTaskStatusFailure(err))
                callback && callback(err);
            });
    }
}

function claimingTask() { return { type: CLAIMING_TASK } }
function claimingTaskSuccess(task) { return { type: CLAIMING_TASK_SUCCESS, task: task } }
function claimingTaskFailure(err) { return { type: CLAIMING_TASK_FAILURE, error: err } }
export function claimTask(task) {
    return (dispatch) => {
        dispatch(claimingTask());
        Tasks.claim(task)
            .then(data => {
                dispatch(claimingTaskSuccess(data.task));
            })
            .catch(err => {
                dispatch(claimingTaskFailure(err))
            });
    }
}

function acceptingTask() { return { type: ACCEPTING_TASK } }
function acceptingTaskSuccess(task) { return { type: ACCEPTING_TASK_SUCCESS, task: task } }
function acceptingTaskFailure(err) { return { type: ACCEPTING_TASK_FAILURE, error: err } }
export function acceptTask(task) {
    return (dispatch) => {
        dispatch(acceptingTask());
        Tasks.accept(task)
            .then(data => {
                dispatch(acceptingTaskSuccess(data.task));
            })
            .catch(err => {
                dispatch(acceptingTaskFailure(err))
            });
    }
}

function refusingTask() { return { type: REFUSING_TASK } }
function refusingTaskSuccess(task) { return { type: REFUSING_TASK_SUCCESS, task: task } }
function refusingTaskFailure(err) { return { type: REFUSING_TASK_FAILURE, error: err } }
export function refuseTask(task) {
    return (dispatch) => {
        dispatch(refusingTask());
        Tasks.refuse(task)
            .then(data => {
                const task = data.task;
                dispatch(refusingTaskSuccess(task));
            })
            .catch(err => {
                dispatch(refusingTaskFailure(err))
            });
    }
}

function renouncingTask() { return { type: RENOUNCING_TASK } }
function renouncingTaskSuccess(task) { return { type: RENOUNCING_TASK_SUCCESS, task: task } }
function renouncingTaskFailure(err) { return { type: RENOUNCING_TASK_FAILURE, error: err } }
export function renounceTask(task, msg) {
    return (dispatch) => {
        dispatch(renouncingTask());
        Tasks.renounce(task, msg)
            .then(data => {
                const task = data.task;
                dispatch(renouncingTaskSuccess(task));
            })
            .catch(err => {
                dispatch(renouncingTaskFailure(err))
            });
    }
}

export const getTasksLinkedResources = linkedResourcesAction;
